/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetCustomerUpdateQueryVariables = Types.Exact<{
  relationId: Types.Scalars['Long']['input'];
}>;


export type GetCustomerUpdateQuery = {
  __typename?: 'Query',
  customerUpdate: {
    __typename?: 'CustomerUpdate',
    id: number,
    relationId: number,
    isCommunicated: boolean,
    lastSentOn?: number | null,
    updatedOn: number,
    cargos: Array<{
      __typename?: 'CustomerUpdateCargo',
      cargoId: number,
      statusChangeId?: number | null,
      comment?: string | null,
      estimateTime?: number | null
    }>,
    ships: Array<{
      __typename?: 'CustomerUpdateShip',
      shipId: number,
      location?: string | null
    }>
  }
};

export type GetCustomerUpdatesQueryVariables = Types.Exact<{
  relationIds: Array<Types.Scalars['Long']['input']>;
}>;


export type GetCustomerUpdatesQuery = {
  __typename?: 'Query',
  customerUpdates: Array<{
    __typename?: 'CustomerUpdate',
    id: number,
    relationId: number,
    isCommunicated: boolean,
    lastSentOn?: number | null,
    updatedOn: number,
    cargos: Array<{
      __typename?: 'CustomerUpdateCargo',
      cargoId: number,
      statusChangeId?: number | null,
      comment?: string | null,
      estimateTime?: number | null
    }>,
    ships: Array<{
      __typename?: 'CustomerUpdateShip',
      shipId: number,
      location?: string | null
    }>
  }>
};

export type SalesChartersQueryVariables = Types.Exact<{
  search: Types.CharterSearch;
  pagination: Types.Pagination;
}>;


export type SalesChartersQuery = {
  __typename?: 'Query',
  salesCharters: {
    __typename?: 'SalesCharterPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'SalesCharter',
      id: number,
      type: Types.CharterType,
      charterNumber: string,
      firstLoadingDate?: number | null,
      subtype: Types.CharterSubtype,
      shortNotice: boolean,
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          email?: string | null
        }>
      },
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      broker?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        email?: string | null,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          email?: string | null
        }>
      } | null,
      cargos: Array<{
        __typename?: 'Cargo',
        id: number,
        weight?: number | null,
        volume?: number | null,
        isWeightPrimary: boolean,
        isVolumePrimary: boolean,
        waterLevelOptimised: boolean,
        cargoNumber?: string | null,
        totalLoadingWeight?: number | null,
        nominatedWeight?: number | null,
        created?: number | null,
        charter?: {
          __typename?: 'SalesCharter',
          broker?: {
            __typename?: 'Relation',
            id: number
          } | null,
          voyages?: Array<{
            __typename?: 'Voyage',
            id: number,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string,
              position?: {
                __typename?: 'ShipPosition',
                id?: number | null,
                latitude?: number | null,
                longitude?: number | null,
                course?: number | null,
                speed?: number | null,
                timestamp?: number | null,
                source?: string | null,
                location?: string | null,
                locationEntered?: number | null,
                communicatedToCustomer?: number | null,
                ship?: {
                  __typename?: 'Ship',
                  id: number,
                  name: string
                } | null
              } | null,
              nextCall?: {
                __typename?: 'Call',
                pta?: number | null,
                eta?: number | null,
                ata?: number | null,
                ptd?: number | null,
                etd?: number | null,
                atd?: number | null,
                etso?: number | null,
                eteo?: number | null,
                atso?: number | null,
                ateo?: number | null,
                etfm?: number | null,
                etlm?: number | null,
                atfm?: number | null,
                atlm?: number | null,
                atn?: number | null,
                dtn?: number | null,
                systemAta?: number | null,
                systemAtd?: number | null,
                systemEta?: number | null,
                systemEtd?: number | null
              } | null
            }
          }> | null,
          debtor: {
            __typename?: 'Relation',
            id: number
          }
        } | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          callEstimateTime?: number | null,
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          callEstimateTime?: number | null,
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>,
        product?: {
          __typename?: 'Product',
          id: number,
          code?: string | null,
          name: string
        } | null,
        firstLoadingAction?: {
          __typename?: 'CargoAction',
          id: number,
          shipToShip?: boolean | null,
          connectingVisitNotes?: string | null,
          start?: number | null,
          end?: number | null,
          simulatedTimestamp?: boolean | null,
          displayAsWindow?: boolean | null,
          connectingShipPortVisit?: {
            __typename?: 'ConnectingShipPortVisit',
            id: number,
            from?: number | null,
            until?: number | null,
            lastUpdateFromAgentOn?: number | null,
            location: {
              __typename?: 'Location',
              id: number,
              description: string
            },
            agent?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string,
              bargeType?: Types.BargeType | null,
              mmsi?: number | null,
              eni?: string | null,
              planningNotes?: string | null,
              tanks: Array<{
                __typename?: 'Tank',
                id: number,
                positionNumber: number
              }>
            },
            connectingShipBerthings?: Array<{
              __typename?: 'ConnectingShipBerthing',
              window?: {
                __typename?: 'TimeWindow',
                from?: number | null,
                to?: number | null
              } | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string
              } | null
            }> | null
          } | null,
          connectingShipBerthing?: {
            __typename?: 'ConnectingShipBerthing',
            id?: number | null,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              locationGroups: Array<{
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null
          } | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            locationGroups: Array<{
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null,
          viaLocation?: {
            __typename?: 'Location',
            id: number,
            description: string,
            locationGroups: Array<{
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null,
          call?: {
            __typename?: 'Call',
            id: number,
            voyage: {
              __typename?: 'Voyage',
              id: number,
              voyageNumber: string,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string
              }
            }
          } | null,
          measurements: {
            __typename?: 'Measurements',
            locationWeight?: number | null,
            locationWeightUnit?: Types.WeightUnit | null,
            skipperWeight?: number | null,
            skipperWeightUnit?: Types.WeightUnit | null,
            locationVolume?: number | null,
            locationVolumeUnit?: Types.VolumeUnit | null,
            skipperVolume?: number | null,
            skipperVolumeUnit?: Types.VolumeUnit | null,
            ambientVolume?: number | null,
            relativeDensity?: number | null,
            productTemperature?: number | null,
            actualConsignor?: string | null,
            actualConsignee?: string | null,
            protest?: boolean | null
          }
        } | null,
        lastDischargingAction?: {
          __typename?: 'CargoAction',
          id: number,
          shipToShip?: boolean | null,
          connectingVisitNotes?: string | null,
          start?: number | null,
          end?: number | null,
          simulatedTimestamp?: boolean | null,
          displayAsWindow?: boolean | null,
          connectingShipPortVisit?: {
            __typename?: 'ConnectingShipPortVisit',
            id: number,
            from?: number | null,
            until?: number | null,
            lastUpdateFromAgentOn?: number | null,
            location: {
              __typename?: 'Location',
              id: number,
              description: string
            },
            agent?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string,
              bargeType?: Types.BargeType | null,
              mmsi?: number | null,
              eni?: string | null,
              planningNotes?: string | null,
              tanks: Array<{
                __typename?: 'Tank',
                id: number,
                positionNumber: number
              }>
            },
            connectingShipBerthings?: Array<{
              __typename?: 'ConnectingShipBerthing',
              window?: {
                __typename?: 'TimeWindow',
                from?: number | null,
                to?: number | null
              } | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string
              } | null
            }> | null
          } | null,
          connectingShipBerthing?: {
            __typename?: 'ConnectingShipBerthing',
            id?: number | null,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              locationGroups: Array<{
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null
          } | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            locationGroups: Array<{
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null,
          viaLocation?: {
            __typename?: 'Location',
            id: number,
            description: string,
            locationGroups: Array<{
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null,
          call?: {
            __typename?: 'Call',
            id: number,
            voyage: {
              __typename?: 'Voyage',
              id: number,
              voyageNumber: string,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string
              }
            }
          } | null,
          measurements: {
            __typename?: 'Measurements',
            locationWeight?: number | null,
            locationWeightUnit?: Types.WeightUnit | null,
            skipperWeight?: number | null,
            skipperWeightUnit?: Types.WeightUnit | null,
            locationVolume?: number | null,
            locationVolumeUnit?: Types.VolumeUnit | null,
            skipperVolume?: number | null,
            skipperVolumeUnit?: Types.VolumeUnit | null,
            ambientVolume?: number | null,
            relativeDensity?: number | null,
            productTemperature?: number | null,
            actualConsignor?: string | null,
            actualConsignee?: string | null,
            protest?: boolean | null
          }
        } | null
      }>,
      voyages?: Array<{
        __typename?: 'Voyage',
        id: number,
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string,
          position?: {
            __typename?: 'ShipPosition',
            id?: number | null,
            latitude?: number | null,
            longitude?: number | null,
            course?: number | null,
            speed?: number | null,
            timestamp?: number | null,
            source?: string | null,
            location?: string | null,
            locationEntered?: number | null,
            communicatedToCustomer?: number | null,
            ship?: {
              __typename?: 'Ship',
              id: number,
              name: string
            } | null
          } | null
        },
        lastStatusChange?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            closedStatus: boolean,
            finishedStatus: boolean
          }
        } | null
      }> | null,
      contacts?: Array<{
        __typename?: 'SalesCharterContact',
        contactRoleType: Types.ContactRoleType,
        contact: {
          __typename?: 'Contact',
          id: number,
          name?: string | null,
          email?: string | null
        }
      }> | null,
      status: {
        __typename?: 'SalesCharterStatusType',
        name: Types.SalesCharterStatus,
        color: string,
        languageKeyPrefix: string
      }
    }> | null
  }
};


export const GetCustomerUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"relationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerUpdateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerUpdateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"isCommunicated"}},{"kind":"Field","name":{"kind":"Name","value":"lastSentOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoId"}},{"kind":"Field","name":{"kind":"Name","value":"statusChangeId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]} as unknown as DocumentNode<GetCustomerUpdateQuery, GetCustomerUpdateQueryVariables>;
export const GetCustomerUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"relationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerUpdateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerUpdateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"relationId"}},{"kind":"Field","name":{"kind":"Name","value":"isCommunicated"}},{"kind":"Field","name":{"kind":"Name","value":"lastSentOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoId"}},{"kind":"Field","name":{"kind":"Name","value":"statusChangeId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]} as unknown as DocumentNode<GetCustomerUpdatesQuery, GetCustomerUpdatesQueryVariables>;
export const SalesChartersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesCharters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharterSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesCharters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesCharterStatusChangeSalesCharter"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingDate"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"shipPosition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerUpdateStatusChange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerUpdateStatusChange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viaLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viaLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalLoadingWeight"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"shipPosition"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactRoleType"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"shortNotice"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesCharterStatusChangeSalesCharter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailWillBeSentToContactsAlertSalesCharterContact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailWillBeSentToContactsAlertSalesCharterContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharterContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactRoleType"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"shipPosition"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShipPosition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"course"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"locationEntered"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerUpdateStatusChange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"callEstimateTime"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}}]} as unknown as DocumentNode<SalesChartersQuery, SalesChartersQueryVariables>;